import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Autocomplete,
  FormControlLabel,
  Switch,
  Stack,
} from "@mui/material";
import MDButton from "components/MDButton";
import { useTranslation } from "react-i18next";

const AddTemplateDetailDialog = ({ open, onClose, onSubmit, availableComponents }) => {
  const { t } = useTranslation();
  const [salaryComponentId, setSalaryComponentId] = useState("");
  const [defaultAmount, setDefaultAmount] = useState("0");
  const [required, setRequired] = useState(false);
  const [editable, setEditable] = useState(true);

  const handleClose = () => {
    setSalaryComponentId("");
    setDefaultAmount("0");
    setRequired(false);
    setEditable(true);
    onClose();
  };

  const handleSubmit = () => {
    onSubmit({
      salaryComponentId,
      defaultAmount: Number(defaultAmount) || 0,
      required,
      editable,
      displayOrder: 0,
    });
    handleClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ fontWeight: "bold" }}>
        {t("admin.payroll.templates.addDetailTitle")}
      </DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <Autocomplete
            options={availableComponents}
            getOptionLabel={(c) => `${c.name} (${c.code})`}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            value={availableComponents.find((c) => c.id === salaryComponentId) || null}
            onChange={(event, newValue) => setSalaryComponentId(newValue?.id || "")}
            renderInput={(params) => (
              <TextField {...params} label={t("admin.payroll.templates.component")} />
            )}
          />
          <TextField
            label={t("admin.payroll.templates.defaultAmount")}
            type="number"
            value={defaultAmount}
            onChange={(e) => setDefaultAmount(e.target.value)}
            fullWidth
            helperText={t("admin.payroll.templates.defaultAmountHelper")}
          />
          <FormControlLabel
            control={<Switch checked={required} onChange={(e) => setRequired(e.target.checked)} />}
            label={t("admin.payroll.templates.required")}
          />
          <FormControlLabel
            control={<Switch checked={editable} onChange={(e) => setEditable(e.target.checked)} />}
            label={t("admin.payroll.templates.editable")}
          />
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <MDButton onClick={handleClose} color="secondary">
          {t("common.cancel")}
        </MDButton>
        <MDButton onClick={handleSubmit} color="primary" disabled={!salaryComponentId}>
          {t("common.add")}
        </MDButton>
      </DialogActions>
    </Dialog>
  );
};

AddTemplateDetailDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  availableComponents: PropTypes.array,
};

AddTemplateDetailDialog.defaultProps = {
  availableComponents: [],
};

export default AddTemplateDetailDialog;
